import { getLocaleDateTimeFormat } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { ChartType } from 'angular-google-charts';
import { PrincipalDasboardLibService } from './../principal-dasboard-lib.service';
declare let require: any;

@Component({
  selector: 'lib-chartheader',
  templateUrl: './chartheader.component.html',
  styleUrls: ['./chartheader.component.scss'],
})
export class ChartheaderComponent implements OnInit {
  constructor(
    private pdService: PrincipalDasboardLibService
  ) {}
  
  //variables
  mytype = ChartType.Timeline;
  datadisplaytype = 'UserWise';
  isUserWise = true;
  myIcon: any;
  libVersion:any;

  ngOnInit(): void {
    this.libVersion = "0.0.13";
    this.myIcon = document.getElementById('myIconImg');
    // this.changeChatType() 
  }
  changeChatType() {
    if (this.mytype == ChartType.Timeline) {
      this.mytype = ChartType.Table;
      this.pdService.chartType.next(this.mytype);
      this.myIcon.src = 'assets/btn_graph.png';
    } else {
      this.mytype = ChartType.Timeline;
      this.myIcon.src = 'assets/btn_table.png';
      this.pdService.chartType.next(this.mytype);
    }
  }
  changeDataTypeClassRoom() {
    this.isUserWise = false;
    this.pdService.isUserWise_data.next(false);
  }
  changeDataTypeUser() {
    this.isUserWise = true;
    this.pdService.isUserWise_data.next(true);
  }
}
